// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    AdmissionSourceType,
    AdmissionSourceTypeFromJSON,
    AdmissionSourceTypeToJSON,
    AdmissionType,
    AdmissionTypeFromJSON,
    AdmissionTypeToJSON,
    ClassificationCodeType,
    ClassificationCodeTypeFromJSON,
    ClassificationCodeTypeToJSON,
    FacilityCodeType,
    FacilityCodeTypeFromJSON,
    FacilityCodeTypeToJSON,
    FrequencyCodeType,
    FrequencyCodeTypeFromJSON,
    FrequencyCodeTypeToJSON,
    HourType,
    HourTypeFromJSON,
    HourTypeToJSON,
    PatientStatusType,
    PatientStatusTypeFromJSON,
    PatientStatusTypeToJSON,
    StateType,
    StateTypeFromJSON,
    StateTypeToJSON,
    SupportCreateClaimInstitutionalConditionCodes,
    SupportCreateClaimInstitutionalConditionCodesFromJSON,
    SupportCreateClaimInstitutionalConditionCodesToJSON,
    SupportCreateClaimInstitutionalExternalCauseOfInjuryDiagnosisCodes,
    SupportCreateClaimInstitutionalExternalCauseOfInjuryDiagnosisCodesFromJSON,
    SupportCreateClaimInstitutionalExternalCauseOfInjuryDiagnosisCodesToJSON,
    SupportCreateClaimInstitutionalOccurrenceSpan,
    SupportCreateClaimInstitutionalOccurrenceSpanFromJSON,
    SupportCreateClaimInstitutionalOccurrenceSpanToJSON,
    SupportCreateClaimInstitutionalOccurrences,
    SupportCreateClaimInstitutionalOccurrencesFromJSON,
    SupportCreateClaimInstitutionalOccurrencesToJSON,
    SupportCreateClaimInstitutionalOtherDiagnosisCodes,
    SupportCreateClaimInstitutionalOtherDiagnosisCodesFromJSON,
    SupportCreateClaimInstitutionalOtherDiagnosisCodesToJSON,
    SupportCreateClaimInstitutionalOtherProcedureCodes,
    SupportCreateClaimInstitutionalOtherProcedureCodesFromJSON,
    SupportCreateClaimInstitutionalOtherProcedureCodesToJSON,
    SupportCreateClaimInstitutionalPatientReasonForVisitDiagnosisCodes,
    SupportCreateClaimInstitutionalPatientReasonForVisitDiagnosisCodesFromJSON,
    SupportCreateClaimInstitutionalPatientReasonForVisitDiagnosisCodesToJSON,
    SupportCreateClaimInstitutionalServices,
    SupportCreateClaimInstitutionalServicesFromJSON,
    SupportCreateClaimInstitutionalServicesToJSON,
    SupportCreateClaimInstitutionalValueCodes,
    SupportCreateClaimInstitutionalValueCodesFromJSON,
    SupportCreateClaimInstitutionalValueCodesToJSON,
    SupportCreateClaimTypePayload,
    SupportCreateClaimTypePayloadFromJSON,
    SupportCreateClaimTypePayloadToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupportCreateClaimInstitutionalPayload
 */
export interface SupportCreateClaimInstitutionalPayload extends SupportCreateClaimTypePayload {
    /**
     * 
     * OpenAPI data type: {FacilityCodeType}
     * @type {FacilityCodeType}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    typeOfBill2ndDigitTypeOfFacilityCode?: FacilityCodeType;
    /**
     * 
     * OpenAPI data type: {ClassificationCodeType}
     * @type {ClassificationCodeType}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    typeOfBill3rdDigitBillClassificationCode?: ClassificationCodeType;
    /**
     * 
     * OpenAPI data type: {FrequencyCodeType}
     * @type {FrequencyCodeType}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    typeOfBill4thDigitFrequencyCode?: FrequencyCodeType;
    /**
     * Field 6 statement from date for the service covered on the claim
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    statementFromDate?: string;
    /**
     * Field 6 statement through date for the service covered on the claim
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    statementThroughDate?: string;
    /**
     * Field 12 admission date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    admissionDate?: string;
    /**
     * 
     * OpenAPI data type: {HourType}
     * @type {HourType}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    admissionHour?: HourType;
    /**
     * 
     * OpenAPI data type: {AdmissionType}
     * @type {AdmissionType}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    admissionType?: AdmissionType;
    /**
     * 
     * OpenAPI data type: {AdmissionSourceType}
     * @type {AdmissionSourceType}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    admissionSource?: AdmissionSourceType;
    /**
     * 
     * OpenAPI data type: {HourType}
     * @type {HourType}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    dischargeHour?: HourType;
    /**
     * 
     * OpenAPI data type: {PatientStatusType}
     * @type {PatientStatusType}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    patientStatus?: PatientStatusType;
    /**
     * Field 21 diagnosis code
     * OpenAPI data type: {array}
     * @type {Array<SupportCreateClaimInstitutionalConditionCodes>}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    conditionCodes?: Array<SupportCreateClaimInstitutionalConditionCodes>;
    /**
     * 
     * OpenAPI data type: {StateType}
     * @type {StateType}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    accidentState?: StateType;
    /**
     * Field 31+ occurrences
     * OpenAPI data type: {array}
     * @type {Array<SupportCreateClaimInstitutionalOccurrences>}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    occurrences?: Array<SupportCreateClaimInstitutionalOccurrences>;
    /**
     * Field 35+ occurrence spans
     * OpenAPI data type: {array}
     * @type {Array<SupportCreateClaimInstitutionalOccurrenceSpan>}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    occurrenceSpans?: Array<SupportCreateClaimInstitutionalOccurrenceSpan>;
    /**
     * Field 39+ value codes
     * OpenAPI data type: {array}
     * @type {Array<SupportCreateClaimInstitutionalValueCodes>}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    valueCodes?: Array<SupportCreateClaimInstitutionalValueCodes>;
    /**
     * Field 67 principal diagnosis code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    principalDiagnosisCode?: string;
    /**
     * Field 67 other diagnosis codes
     * OpenAPI data type: {array}
     * @type {Array<SupportCreateClaimInstitutionalOtherDiagnosisCodes>}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    otherDiagnosisCodes?: Array<SupportCreateClaimInstitutionalOtherDiagnosisCodes>;
    /**
     * Field 69 admitting diagnosis code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    admittingDiagnosisCode?: string;
    /**
     * Field 70+ reason for visit diagnosis codes
     * OpenAPI data type: {array}
     * @type {Array<SupportCreateClaimInstitutionalPatientReasonForVisitDiagnosisCodes>}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    patientReasonForVisitDiagnosisCodes?: Array<SupportCreateClaimInstitutionalPatientReasonForVisitDiagnosisCodes>;
    /**
     * Field 72 external cause of injury codes
     * OpenAPI data type: {array}
     * @type {Array<SupportCreateClaimInstitutionalExternalCauseOfInjuryDiagnosisCodes>}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    externalCauseOfInjuryDiagnosisCodes?: Array<SupportCreateClaimInstitutionalExternalCauseOfInjuryDiagnosisCodes>;
    /**
     * Field 74 principal procedure code
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    principalProcedureCode?: string;
    /**
     * Field 74 principal procedure code
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    principalProcedureDate?: string;
    /**
     * Field 74 principal procedure code
     * OpenAPI data type: {array}
     * @type {Array<SupportCreateClaimInstitutionalOtherProcedureCodes>}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    otherProcedureCodes?: Array<SupportCreateClaimInstitutionalOtherProcedureCodes>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<SupportCreateClaimInstitutionalServices>}
     * @memberof SupportCreateClaimInstitutionalPayload
     */
    services?: Array<SupportCreateClaimInstitutionalServices>;
}

export function SupportCreateClaimInstitutionalPayloadFromJSON(json: any): SupportCreateClaimInstitutionalPayload {
    return {
                'typeOfBill2ndDigitTypeOfFacilityCode': !exists(json, 'typeOfBill2ndDigitTypeOfFacilityCode') ? undefined : FacilityCodeTypeFromJSON(json['typeOfBill2ndDigitTypeOfFacilityCode']),
                'typeOfBill3rdDigitBillClassificationCode': !exists(json, 'typeOfBill3rdDigitBillClassificationCode') ? undefined : ClassificationCodeTypeFromJSON(json['typeOfBill3rdDigitBillClassificationCode']),
                'typeOfBill4thDigitFrequencyCode': !exists(json, 'typeOfBill4thDigitFrequencyCode') ? undefined : FrequencyCodeTypeFromJSON(json['typeOfBill4thDigitFrequencyCode']),
                'statementFromDate': !exists(json, 'statementFromDate') ? undefined : json['statementFromDate'],
                'statementThroughDate': !exists(json, 'statementThroughDate') ? undefined : json['statementThroughDate'],
                'admissionDate': !exists(json, 'admissionDate') ? undefined : json['admissionDate'],
                'admissionHour': !exists(json, 'admissionHour') ? undefined : HourTypeFromJSON(json['admissionHour']),
                'admissionType': !exists(json, 'admissionType') ? undefined : AdmissionTypeFromJSON(json['admissionType']),
                'admissionSource': !exists(json, 'admissionSource') ? undefined : AdmissionSourceTypeFromJSON(json['admissionSource']),
                'dischargeHour': !exists(json, 'dischargeHour') ? undefined : HourTypeFromJSON(json['dischargeHour']),
                'patientStatus': !exists(json, 'patientStatus') ? undefined : PatientStatusTypeFromJSON(json['patientStatus']),
                'conditionCodes': !exists(json, 'conditionCodes') ? undefined : (json['conditionCodes'] as Array<any>).map(SupportCreateClaimInstitutionalConditionCodesFromJSON),
                'accidentState': !exists(json, 'accidentState') ? undefined : StateTypeFromJSON(json['accidentState']),
                'occurrences': !exists(json, 'occurrences') ? undefined : (json['occurrences'] as Array<any>).map(SupportCreateClaimInstitutionalOccurrencesFromJSON),
                'occurrenceSpans': !exists(json, 'occurrenceSpans') ? undefined : (json['occurrenceSpans'] as Array<any>).map(SupportCreateClaimInstitutionalOccurrenceSpanFromJSON),
                'valueCodes': !exists(json, 'valueCodes') ? undefined : (json['valueCodes'] as Array<any>).map(SupportCreateClaimInstitutionalValueCodesFromJSON),
                'principalDiagnosisCode': !exists(json, 'principalDiagnosisCode') ? undefined : json['principalDiagnosisCode'],
                'otherDiagnosisCodes': !exists(json, 'otherDiagnosisCodes') ? undefined : (json['otherDiagnosisCodes'] as Array<any>).map(SupportCreateClaimInstitutionalOtherDiagnosisCodesFromJSON),
                'admittingDiagnosisCode': !exists(json, 'admittingDiagnosisCode') ? undefined : json['admittingDiagnosisCode'],
                'patientReasonForVisitDiagnosisCodes': !exists(json, 'patientReasonForVisitDiagnosisCodes') ? undefined : (json['patientReasonForVisitDiagnosisCodes'] as Array<any>).map(SupportCreateClaimInstitutionalPatientReasonForVisitDiagnosisCodesFromJSON),
                'externalCauseOfInjuryDiagnosisCodes': !exists(json, 'externalCauseOfInjuryDiagnosisCodes') ? undefined : (json['externalCauseOfInjuryDiagnosisCodes'] as Array<any>).map(SupportCreateClaimInstitutionalExternalCauseOfInjuryDiagnosisCodesFromJSON),
                'principalProcedureCode': !exists(json, 'principalProcedureCode') ? undefined : json['principalProcedureCode'],
                'principalProcedureDate': !exists(json, 'principalProcedureDate') ? undefined : json['principalProcedureDate'],
                'otherProcedureCodes': !exists(json, 'otherProcedureCodes') ? undefined : (json['otherProcedureCodes'] as Array<any>).map(SupportCreateClaimInstitutionalOtherProcedureCodesFromJSON),
                'services': !exists(json, 'services') ? undefined : (json['services'] as Array<any>).map(SupportCreateClaimInstitutionalServicesFromJSON),
        ...SupportCreateClaimTypePayloadFromJSON(json)
    };

}

export function SupportCreateClaimInstitutionalPayloadToForm(value?: SupportCreateClaimInstitutionalPayload): any {
    let jsonVal = SupportCreateClaimInstitutionalPayloadToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function SupportCreateClaimInstitutionalPayloadToJSON(value?: SupportCreateClaimInstitutionalPayload): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'typeOfBill2ndDigitTypeOfFacilityCode': FacilityCodeTypeToJSON(value.typeOfBill2ndDigitTypeOfFacilityCode),
            'typeOfBill3rdDigitBillClassificationCode': ClassificationCodeTypeToJSON(value.typeOfBill3rdDigitBillClassificationCode),
            'typeOfBill4thDigitFrequencyCode': FrequencyCodeTypeToJSON(value.typeOfBill4thDigitFrequencyCode),
            'statementFromDate': cleanupBlankValuesForBackend(value.statementFromDate),
            'statementThroughDate': cleanupBlankValuesForBackend(value.statementThroughDate),
            'admissionDate': cleanupBlankValuesForBackend(value.admissionDate),
            'admissionHour': HourTypeToJSON(value.admissionHour),
            'admissionType': AdmissionTypeToJSON(value.admissionType),
            'admissionSource': AdmissionSourceTypeToJSON(value.admissionSource),
            'dischargeHour': HourTypeToJSON(value.dischargeHour),
            'patientStatus': PatientStatusTypeToJSON(value.patientStatus),
            'conditionCodes': (value.conditionCodes === undefined || value.conditionCodes === null) ? undefined  : (value.conditionCodes as Array<any>).map(SupportCreateClaimInstitutionalConditionCodesToJSON),
            'accidentState': StateTypeToJSON(value.accidentState),
            'occurrences': (value.occurrences === undefined || value.occurrences === null) ? undefined  : (value.occurrences as Array<any>).map(SupportCreateClaimInstitutionalOccurrencesToJSON),
            'occurrenceSpans': (value.occurrenceSpans === undefined || value.occurrenceSpans === null) ? undefined  : (value.occurrenceSpans as Array<any>).map(SupportCreateClaimInstitutionalOccurrenceSpanToJSON),
            'valueCodes': (value.valueCodes === undefined || value.valueCodes === null) ? undefined  : (value.valueCodes as Array<any>).map(SupportCreateClaimInstitutionalValueCodesToJSON),
            'principalDiagnosisCode': cleanupBlankValuesForBackend(value.principalDiagnosisCode),
            'otherDiagnosisCodes': (value.otherDiagnosisCodes === undefined || value.otherDiagnosisCodes === null) ? undefined  : (value.otherDiagnosisCodes as Array<any>).map(SupportCreateClaimInstitutionalOtherDiagnosisCodesToJSON),
            'admittingDiagnosisCode': cleanupBlankValuesForBackend(value.admittingDiagnosisCode),
            'patientReasonForVisitDiagnosisCodes': (value.patientReasonForVisitDiagnosisCodes === undefined || value.patientReasonForVisitDiagnosisCodes === null) ? undefined  : (value.patientReasonForVisitDiagnosisCodes as Array<any>).map(SupportCreateClaimInstitutionalPatientReasonForVisitDiagnosisCodesToJSON),
            'externalCauseOfInjuryDiagnosisCodes': (value.externalCauseOfInjuryDiagnosisCodes === undefined || value.externalCauseOfInjuryDiagnosisCodes === null) ? undefined  : (value.externalCauseOfInjuryDiagnosisCodes as Array<any>).map(SupportCreateClaimInstitutionalExternalCauseOfInjuryDiagnosisCodesToJSON),
            'principalProcedureCode': cleanupBlankValuesForBackend(value.principalProcedureCode),
            'principalProcedureDate': cleanupBlankValuesForBackend(value.principalProcedureDate),
            'otherProcedureCodes': (value.otherProcedureCodes === undefined || value.otherProcedureCodes === null) ? undefined  : (value.otherProcedureCodes as Array<any>).map(SupportCreateClaimInstitutionalOtherProcedureCodesToJSON),
            'services': (value.services === undefined || value.services === null) ? undefined  : (value.services as Array<any>).map(SupportCreateClaimInstitutionalServicesToJSON),
            ...SupportCreateClaimTypePayloadToJSON(value)
    };
}


